import { Moment } from 'moment'
import React, { useEffect, useMemo, useState } from 'react'

import { useAppSelector } from '../../App/Hooks/reduxHooks'
import { IWorkingHours } from '../../App/store/features/person/interface/IWorkingHours'
import { IAbsence } from '../../App/store/features/person/interface/IWorkingSchedule'
import { Person } from '../../App/store/features/person/IPerson'
import { RootState } from '../../store'
import { ColumnGrid } from '../ColumnGrid'

import { DayWrapper } from './style'

interface IProps {
  date: Moment
  persons: Person[]
  timeDivision: number
  workingHours: IWorkingHours[]
  absences: IAbsence[]
  onEmptySlotClicked: (person: Person, clickedMoment: Moment) => void
}

export const Day = ({
  persons,
  timeDivision,
  date,
  workingHours,
  absences,
  onEmptySlotClicked,
}: IProps) => {
  const [filteredPersons, setFilteredPersons] = useState<Person[]>([])

  const { inActivePersonIds } = useAppSelector((state: RootState) => ({
    inActivePersonIds: state.calendarNew.settings.inActivePersonIds,
  }))

  useMemo(() => {
    setFilteredPersons(
      persons.filter(person => !inActivePersonIds.includes(person.id)),
    )
  }, [inActivePersonIds, persons])

  return (
    <DayWrapper>
      {filteredPersons.map(person => (
        <ColumnGrid
          person={person}
          key={`${person.id}${date}`}
          timeDivision={timeDivision}
          date={date}
          workingHours={workingHours}
          absences={absences}
          onEmptySlotClicked={onEmptySlotClicked}
        />
      ))}
    </DayWrapper>
  )
}
